module.exports = __webpack_public_path__ + "img/usersanalytics.e8fa4b98.png";